import React, { useState } from 'react';

export default function StudyStayLogo({ className = "w-8 h-8" }) {
  const [imageError, setImageError] = useState(false);

  if (imageError) {
    // Fallback logo if image fails to load
    return (
      <div className={`${className} bg-ios-blue rounded-lg flex items-center justify-center`}>
        <span className="text-white text-lg font-bold">S</span>
      </div>
    );
  }

  return (
    <img
      src="/studystay-logo-small.png"
      alt="StudyStay Logo"
      className={`${className} object-contain`}
      onError={() => {
        console.log('Logo failed to load, showing fallback');
        setImageError(true);
      }}
      onLoad={() => {
        console.log('Logo loaded successfully');
        setImageError(false);
      }}
    />
  );
}
